export const MenuData = [
  {
    type: 'collection',
    bannerAd: {
      heading: 'Shop Rubber Flooring',
      btnText: 'Buy Now',
      uri: '/collections/rubber-flooring/',
      img: '../../assets/images/banner-ads/collections.png',
    },
    TopMenuName: 'Flooring Products',
    menus: [
      {
        menuName: 'Rubber Flooring',
        subitems: [
          {
            name: 'Rolls',
            uri: '/collections/rubber-rolls',
          },
          {
            name: 'Tiles',
            uri: '/collections/rubber-tiles',
          },
          {
            name: 'Mats',
            uri: '/collections/rubber-mats',
          },
          {
            name: 'All Products',
            uri: '/collections/rubber-flooring',
          },
        ],
      },
      {
        menuName: 'Hi-Temp Weights',
        subitems: [
          {
            name: 'Hi-Temp Weights',
            uri: '/collections/hi-temp-weights',
          },
        ],
      },
      {
        menuName: 'Home Gym Flooring',
        subitems: [
          {
            name: 'Workout Mats',
            uri: '/collections/rubber-workout-mats',
          },
          {
            name: 'Weightroom Mats',
            uri: '/collections/weight-room-mats',
          },
          {
            name: 'Weightroom Tiles',
            uri: '/collections/weight-room-tiles',
          },
          {
            name: 'Exercise Flooring',
            uri: '/collections/exercise-flooring',
          },
          {
            name: 'Rubber Rolls',
            uri: '/collections/rubber-rolls',
          },
          {
            name: 'All Products',
            uri: '/collections/home-gym-flooring',
          },
        ],
      },
      {
        menuName: 'Commercial Gym Flooring',
        subitems: [
          {
            name: 'Weight Room Flooring',
            uri: '/collections/weight-room-flooring',
          },
          {
            name: 'Aerobic Flooring',
            uri: '/collections/aerobic-flooring',
          },
          {
            name: 'Gym Flooring',
            uri: '/collections/gym-flooring',
          },
          {
            name: 'All Products',
            uri: '/collections/commercial-gym-flooring',
          },
        ],
      },
      {
        menuName: 'Rubber Underlayment',
        subitems: [
          {
            name: 'Rubber Underlayment',
            uri: '/collections/rubber-underlayment',
          },
        ],
      },
      {
        menuName: 'Crossfit Flooring',
        subitems: [
          {
            name: 'Rolls',
            uri: '/collections/rubber-rolls',
          },
          {
            name: 'Tiles',
            uri: '/collections/rubber-tiles',
          },
          {
            name: 'Mats',
            uri: '/collections/rubber-mats',
          },
          {
            name: 'All Products',
            uri: '/collections/crossfit-flooring',
          },
        ],
      },
      {
        menuName: 'Ice Rink Flooring',
        subitems: [
          {
            name: 'Rolls',
            uri: '/collections/rubber-rolls',
          },
          {
            name: 'Tiles',
            uri: '/collections/rubber-tiles',
          },
          {
            name: 'Mats',
            uri: '/collections/rubber-mats',
          },
          {
            name: 'All Products',
            uri: '/collections/ice-rink-flooring',
          },
        ],
      },
      {
        menuName: 'Basement Flooring',
        subitems: [
          {
            name: 'Rolls',
            uri: '/collections/rubber-rolls',
          },
          {
            name: 'Tiles',
            uri: '/collections/rubber-tiles',
          },
          {
            name: 'Mats',
            uri: '/collections/rubber-mats',
          },
          {
            name: 'All Products',
            uri: '/collections/basement-flooring',
          },
        ],
      },
      {
        menuName: 'Playground',
        subitems: [
          {
            name: 'Playground Flooring',
            uri: '/collections/playground-flooring-and-equipment',
          },
        ],
      },
      {
        menuName: 'Garage Flooring',
        subitems: [
          {
            name: 'Tiles',
            uri: '/collections/garage-tiles',
          },
          {
            name: 'Automotive',
            uri: '/collections/automotive-flooring',
          },
          {
            name: 'Mats',
            uri: '/collections/rubber-mats',
          },
          {
            name: 'All Products',
            uri: '/collections/garage-flooring',
          },
        ],
      },
    ],
  },
  {
    type: 'category',
    bannerAd: {
      heading: 'Shop Rubber Flooring',
      btnText: 'Buy Now',
      uri: '/rubber-flooring/',
      img: '../../assets/images/banner-ads/collections.png',
    },
    TopMenuName: 'Flooring by Category',
    menus: [
      // {
      //   menuName: 'Accessories',
      //   uri: '/accessories',
      // },
      // {
      //   menuName: 'Basement Flooring',
      //   uri: '/basement-flooring',
      // },
      // {
      //   menuName: 'Commercial Gym Flooring',
      //   uri: '/commercial-gym-flooring',
      // },
      // {
      //   menuName: 'Crossfit Flooring',
      //   uri: '/crossfit-flooring',
      // },
      // {
      //   menuName: 'Garage Rubber Flooring',
      //   uri: '/garage-rubber-flooring',
      // },
      // {
      //   menuName: 'Hi-Temp Weight',
      //   uri: '/hi-temp-weight',
      // },
      // {
      //   menuName: 'Home Gym Flooring',
      //   uri: '/home-gym-flooring',
      // },
      // {
      //   menuName: 'Ice Rink Flooring',
      //   uri: '/ice-rink-flooring',
      // },
      // {
      //   menuName: 'Playground Flooring',
      //   uri: '/playground-flooring',
      // },
      {
        menuName: 'Rubber Flooring',
        uri: '/rubber-flooring',
      },
      {
        menuName: 'Gym Flooring',
        uri: '/gym-flooring',
      },
      // {
      //   menuName: 'Rubber Flooring Mats',
      //   uri: '/rubber-flooring-mats',
      // },
      // {
      //   menuName: 'Rubber Rolls',
      //   uri: '/rubber-rolls',
      // },
      // {
      //   menuName: 'Rubber Tiles',
      //   uri: '/rubber-tiles',
      // },
      // {
      //   menuName: 'Rubber Underlayment',
      //   uri: '/rubber-underlayment',
      // },
    ],
  },
  {
    type: 'education',
    bannerAd: {
      heading: "Rubber Flooring Buyer's Guide",
      btnText: 'Learn More',
      uri: '/buyers-guide/rubber-flooring',
      img: '../../assets/images/banner-ads/education.png',
    },
    TopMenuName: 'Education Center',
    menus: [
      {
        menuName: 'Rubber Flooring',
        subitems: [
          {
            name: 'Flooring',
            uri: '/buyers-guide/rubber-flooring',
          },
          {
            name: 'Mats',
            uri: '/buyers-guide/rubber-mats',
          },
          {
            name: 'Rolls',
            uri: '/buyers-guide/rubber-rolls',
          },
          {
            name: 'Tiles',
            uri: '/buyers-guide/rubber-tiles',
          },
        ],
      },
      {
        menuName: 'Garage Flooring',
        subitems: [
          {
            name: 'Garage Flooring',
            uri: '/buyers-guide/garage-flooring',
          },
          {
            name: 'Automotive Flooring',
            uri: '/buyers-guide/automotive-flooring',
          },
          {
            name: 'Rubber Mats',
            uri: '/buyers-guide/rubber-mats',
          },
        ],
      },
      {
        menuName: 'Home Gym Flooring',
        subitems: [
          {
            name: 'Home Gym Flooring',
            uri: '/buyers-guide/home-gym-flooring',
          },
          {
            name: 'Gym Flooring',
            uri: '/buyers-guide/gym-flooring',
          },
          {
            name: 'Gym Mats',
            uri: '/buyers-guide/gym-mats',
          },
          {
            name: 'Gym Rolls',
            uri: '/buyers-guide/gym-rolls',
          },
          {
            name: 'Gym Tiles',
            uri: '/buyers-guide/gym-tiles',
          },
          {
            name: 'Exercise Flooring',
            uri: '/buyers-guide/exercise-flooring',
          },
        ],
      },
      {
        menuName: 'Commercial Gym Flooring',
        subitems: [
          {
            name: 'Commercial Gym',
            uri: '/buyers-guide/commercial-gym',
          },
          {
            name: 'Weight Room Flooring',
            uri: '/buyers-guide/weight-room-flooring',
          },
          {
            name: 'Aerobic Flooring',
            uri: '/buyers-guide/aerobic-flooring',
          },
          {
            name: 'Gym Flooring',
            uri: '/buyers-guide/gym-flooring',
          },
        ],
      },
      {
        menuName: 'Rubber Underlayment',
        subitems: [
          {
            name: 'Underlayment',
            uri: '/buyers-guide/underlayment',
          },
        ],
      },
      {
        menuName: 'Crossfit Flooring',
        subitems: [
          {
            name: 'Crossfit Flooring',
            uri: '/buyers-guide/commercial-gym',
          },
          {
            name: 'Rubber Mats',
            uri: '/buyers-guide/weight-room-flooring',
          },
          {
            name: 'Rubber Rolls',
            uri: '/buyers-guide/aerobic-flooring',
          },
          {
            name: 'Rubber Tiles',
            uri: '/buyers-guide/gym-flooring',
          },
        ],
      },
      {
        menuName: 'Ice Rink Flooring',
        subitems: [
          {
            name: 'Rubber Flooring',
            uri: '/buyers-guide/rubber-flooring',
          },
          {
            name: 'Rubber Mats',
            uri: '/buyers-guide/rubber-mats',
          },
          {
            name: 'Rubber Rolls',
            uri: '/buyers-guide/rubber-rolls',
          },
          {
            name: 'Rubber Tiles',
            uri: '/buyers-guide/rubber-tiles',
          },
        ],
      },
      {
        menuName: 'Basement Flooring',
        subitems: [
          {
            name: 'Basement Flooring',
            uri: '/buyers-guide/basement-flooring',
          },
        ],
      },
      {
        menuName: 'Blog',
        subitems: [
          {
            name: 'Latest Posts',
            uri: '/blog',
          },
        ],
      },
    ],
  },
  {
    type: 'deals',
    bannerAd: {
      heading: 'Featured Deals',
      btnText: 'See All',
      uri: '/collections/featured-deals/',
      img: '../../assets/images/banner-ads/deals.png',
    },
    TopMenuName: 'Best Sellers',
    uri: '/collections/best-sellers',
    menus: [
      {
        menuName: 'Featured Deals',
        uri: '/collections/featured-deals/',
      },
      {
        menuName: 'Best Sellers',
        uri: '/collections/best-sellers/',
      },
      {
        menuName: 'Clearance',
        uri: '/collections/clearance/',
      },
    ],
  },
]
